import { render, staticRenderFns } from "./UnassignedPersonViewer.vue?vue&type=template&id=57c4cf5a&scoped=true"
import script from "./UnassignedPersonViewer.vue?vue&type=script&lang=js"
export * from "./UnassignedPersonViewer.vue?vue&type=script&lang=js"
import style0 from "./UnassignedPersonViewer.vue?vue&type=style&index=0&id=57c4cf5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c4cf5a",
  null
  
)

export default component.exports